import React from 'react';
import { advancedTranslation, checkInApp, getAppRegion, translationFactory } from 'packages/common/utils';
import { TUXProvider } from '@byted-tiktok/tux-components';
import { ConfigConsumerProps } from 'packages/common';
import { getFormater } from 'packages/common/time-format';
import { TransformedLocaleConfig } from '@byted/date-fmt/dist/type';
import { TFunction } from 'packages/common/utils';
import EventBus from '../event-bus';
type AbTestParams = {
  [paramScope: string]: {
    versionId: number; // abtest group version_name

    value: Record<string, number | string>; // abtest group parameters

  };
};
export type AppLayoutPropsType = {
  ___commonParams: {
    query: Record<string, string>;
    userAgent: string;
    isIOS: boolean;
    isPC?: boolean;
    starlingData: Record<string, string>;
    tccData: ConfigConsumerProps;
    dateFormatConfig: TransformedLocaleConfig & {
      meridiem: string;
    };
    abGroups: AbTestParams;
  };
  ___dataSource: unknown[];
};
export interface AppContext {
  query: Record<string, string>;
  isIOS: boolean;
  appRegion: string;
  config: ConfigConsumerProps;
  dir: 'rtl' | 'ltr';
  isInApp: boolean;
  t: TFunction;
  advancedT: TFunction;
  dateFormat: ReturnType<typeof getFormater>;
  dataSource: unknown[];
  eventBus: EventBus;
  abGroups: AbTestParams;
}
export const formatAppContext = (props: AppLayoutPropsType): AppContext => {
  const {
    ___commonParams
  } = props;
  const {
    lng,
    dir: queryDir
  } = ___commonParams.query;
  const dir: 'rtl' | 'ltr' = queryDir === 'rtl' || ['ar', 'he', 'ur'].some(key => lng?.startsWith(key)) ? 'rtl' : 'ltr'; // starling

  const translation = translationFactory(___commonParams.starlingData || {}, lng);
  const advancedT = advancedTranslation(___commonParams.starlingData || {});
  const isInApp = checkInApp(___commonParams.userAgent);
  const dateFormat = getFormater(___commonParams.dateFormatConfig);
  const appRegion = (getAppRegion(___commonParams.userAgent) as string);
  const configData: AppContext = {
    query: ___commonParams.query,
    isIOS: ___commonParams.isIOS,
    config: ___commonParams.tccData,
    abGroups: ___commonParams.abGroups || {},
    appRegion,
    isInApp,
    t: translation,
    advancedT,
    dir,
    dateFormat,
    dataSource: props.___dataSource,
    eventBus: new EventBus()
  };
  return configData;
};

const TUXLayout: React.FC<AppContext> = props => {
  return <TUXProvider theme="light" dir={props.dir} platform={props.isIOS ? 'iOS' : 'Android'} hasStatusBar={props.isInApp} androidStatusBarHeight={Number(props.query.status_bar_height || 0)}>
      {props.children}
    </TUXProvider>;
};

export default TUXLayout;